export default __webpack_public_path__ + "static/media/file10.42f89b85.jpg";